import React from "react";
import { Button, Chip, TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { Autocomplete } from "@material-ui/lab";
import '../../../style.css'
import { DropdownDateRangePicker } from './SelectDateRange';
import { useSelector } from "react-redux";

const NotMatchedFilter = (props) => {
   const { dateRangeFilter,dateRange } = useSelector(
        (store) => store.gstr2a2bNewRecoReducer
      );
  return (
    <>
      <>
        <div class="filter-main-div">
         
          <div>
            <label
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
              }}
            >
              Select Document Date
            </label>
            <DropdownDateRangePicker   
                        dateRange={dateRangeFilter}   
                        initialStartDate={dateRange[0].startDate}
                        initialEndDate={dateRange[0].endDate}
                        minDate={dateRange[0].startDate}
                        maxDate={dateRange[0].endDate}    
                        />
          </div>
        </div>

        <div className="filter-chips-background">
          <div style={{ display: "flex" }}>
            <div className="filter-chips-heading">Recipient GSTIN</div>
            <div className="filter-chips-background-div">
              {props.rgstinTaxpayerFilter.map((rgstin, i) => (
                <Chip
                  className="filter-chips"
                  label={rgstin}
                  clickable
                  color="primary"
                  onDelete={() => {
                    props.handleChipDelete(i, "rgstin");
                  }}
                />
              ))}
            </div>
          </div>
          <div style={{ display: "flex" }} className="filter-text-input">
            <FormControl fullWidth variant="filled" style={{ width: "40%" }}>
              <label for="filled-adornment-amount" className="filter-label">
              Recipient GSTIN
              </label>

              <Autocomplete
                {...props.defaultPropsRecipientGstins}
                id="auto-complete"
                value={props.recipientGstin}
                onChange={(event, newValue) => {
                  props.onChangeRecipientGstin(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    //margin="normal"
                    style={{ backgroundColor: "#eaeaea" }}
                  />
                )}
              />
            </FormControl>
            <Button
              onClick={props.handleAddRecipientGstin}
              className="filter-add-button"
            >
              + Add
            </Button>
          </div>
        </div>

        <div className="filter-chips-background">
          <div style={{ display: "flex" }}>
            <div className="filter-chips-heading">
            Supplier GSTIN
            </div>
            <div className="filter-chips-background-div">
              {props.sgstinTaxpayerFilter.map((sgstin, i) => (
                <Chip
                  className="filter-chips"
                  label={sgstin}
                  clickable
                  color="primary"
                  onDelete={() => {
                    props.handleChipDelete(i, "sgstin");
                  }}
                />
              ))}
            </div>
          </div>
          <div style={{ display: "flex" }} className="filter-text-input">
            <FormControl fullWidth variant="filled" style={{ width: "40%" }}>
              <label for="filled-adornment-amount" className="filter-label">
              Supplier GSTIN
              </label>

              <Autocomplete
                {...props.defaultPropsSupplierGstins}
                id="auto-complete"
                value={props.supplierGstin}
                onChange={(event, newValue) => {
                  props.onChangeSupplierGstin(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    //margin="normal"
                    style={{ backgroundColor: "#eaeaea" }}
                  />
                )}
              />
            </FormControl>
            <Button
              onClick={props.handleAddSupplierGstin}
              className="filter-add-button"
            >
              + Add
            </Button>
          </div>
        </div>

        <div className="filter-chips-background">
          <div style={{ display: "flex" }}>
            <div className="filter-chips-heading">Document Number</div>
            <div className="filter-chips-background-div">
              {props.inumFilter.map((inum, i) => (
                <Chip
                  className="filter-chips"
                  label={inum}
                  clickable
                  color="primary"
                  onDelete={() => {
                    props.handleChipDelete(i, "Inum");
                  }}
                />
              ))}
            </div>
          </div>
          <div style={{ display: "flex" }} className="filter-text-input">
            <FormControl fullWidth variant="filled" style={{ width: "40%" }}>
              <label for="filled-adornment-amount" className="filter-label">
                Invoice Number
              </label>

              <Autocomplete
                {...props.defaultPropsInum}
                id="auto-complete"
                value={props.inum}
                onChange={(event, newValue) => {
                  props.onChangeInum(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    //margin="normal"
                    style={{ backgroundColor: "#eaeaea" }}
                  />
                )}
              />
            </FormControl>
            <Button onClick={props.handleAddInum} className="filter-add-button">
              + Add
            </Button>
          </div>
        </div>

       
      </>
    </>
  )
}

export default NotMatchedFilter